import { Route, Routes } from 'react-router-dom';

import { AppShell } from '@/components/AppShell';
import { AuditPage } from '@/features/audit/AuditPage';
import { AppsPage } from '@/features/apps/AppsPage';
import { LicenseAssignmentPage } from '@/features/license-assignment/LicenseAssignmentPage';
import { OnboardingPage } from '@/features/onboarding/OnboardingPage';
import { CredentialsPage } from '@/features/settings/CredentialsPage';
import { TenantsPage } from '@/features/tenants/TenantsPage';
import { UsersPage } from '@/features/users/UsersPage';

export function App() {
  return (
    <AppShell>
      <Routes>
        {/* The entry point is the work itself — no dashboard, no landing page. */}
        <Route path="/" element={<LicenseAssignmentPage />} />
        <Route path="/tenants" element={<TenantsPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/apps" element={<AppsPage />} />
        {/* Exists rather than 404s, so a shared link lands somewhere sensible. */}
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/settings/credentials" element={<CredentialsPage />} />
        <Route path="/audit" element={<AuditPage />} />
        <Route path="*" element={<LicenseAssignmentPage />} />
      </Routes>
    </AppShell>
  );
}
